export const Routing = {
    poiList: '/pois',
    poiCreate: '/pois/create',
    poiEdit: '/pois/edit/:id',
    geofenceCreate: '/geofences/create',
    geofenceEdit: '/geofences/edit/:id',
};
